import { useCallback, useMemo } from 'react';

import { useUserStore } from '@/store/userStore';

export const useAvailableActions = () => {
  const userProvider = useUserStore((state) => state.userProvider);
  const setAvailableActionsInStore = useUserStore((state) => state.setAvailableActions);
  const availableActionsInStore = useUserStore((state) => state.availableActions);

  const availableActions = useMemo(() => {
    return new Set([...availableActionsInStore.global, ...availableActionsInStore.auditCase]);
  }, [availableActionsInStore.auditCase, availableActionsInStore.global]);

  const setAvailableActions = useCallback(
    (scope: 'global' | 'auditCase', actions: string[]) => {
      const newAvailableActions = {
        ...useUserStore.getState().availableActions,
        [scope]: actions,
      };

      setAvailableActionsInStore(newAvailableActions);

      userProvider.permissions = [...newAvailableActions.global, ...newAvailableActions.auditCase];
    },
    [setAvailableActionsInStore, userProvider],
  );

  return { availableActions, setAvailableActions };
};
